import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-navy text-sand border-t border-copper/25">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="font-serif text-2xl text-sand">High Achievers Texas</div>
          <div className="divider my-4" />
          <p className="text-sm text-tan leading-relaxed">
            Premium hemp-derived products. Lab-tested, Farm-Bill compliant, and crafted for adults in Texas.
          </p>
          <div className="flex gap-4 mt-6">
            {s?.instagram_url && (
              <a href={s.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-copper hover:text-sand"><Instagram size={20} /></a>
            )}
            {s?.facebook_url && (
              <a href={s.facebook_url} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="text-copper hover:text-sand"><Facebook size={20} /></a>
            )}
            {s?.twitter_url && (
              <a href={s.twitter_url} target="_blank" rel="noreferrer" data-testid="footer-twitter" className="text-copper hover:text-sand"><Twitter size={20} /></a>
            )}
          </div>
        </div>

        <div>
          <div className="eyebrow">Explore</div>
          <ul className="mt-5 space-y-3 text-sm text-tan">
            <li><Link to="/shop" className="hover:text-copper">Shop All Products</Link></li>
            <li><Link to="/learn" className="hover:text-copper">Learn Hemp Basics</Link></li>
            <li><Link to="/lab-reports" className="hover:text-copper">Certificates of Analysis</Link></li>
            <li><Link to="/about" className="hover:text-copper">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-copper">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow">Visit Us</div>
          <ul className="mt-5 space-y-3 text-sm text-tan">
            <li className="flex gap-2"><MapPin size={16} className="text-copper flex-shrink-0 mt-1" /><span>{s?.address_line1}<br/>{s?.address_line2}</span></li>
            <li className="flex gap-2"><Phone size={16} className="text-copper flex-shrink-0 mt-1" /><span>{s?.phone}</span></li>
            <li className="flex gap-2"><Mail size={16} className="text-copper flex-shrink-0 mt-1" /><span>{s?.email}</span></li>
          </ul>
          <div className="mt-6 text-sm text-tan">
            {s?.hours?.map((h, i) => (
              <div key={i} className="flex justify-between border-b border-copper/10 py-2">
                <span>{h.day}</span><span>{h.open} – {h.close}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="eyebrow">Compliance</div>
          <ul className="mt-5 space-y-3 text-sm text-tan">
            <li><Link to="/policies/privacy" className="hover:text-copper">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-copper">Terms and Conditions</Link></li>
            <li><Link to="/policies/refund" className="hover:text-copper">Refund Policy</Link></li>
            <li><Link to="/policies/sales" className="hover:text-copper">Sales Policy</Link></li>
            <li><Link to="/policies/compliance" className="hover:text-copper">Compliance Policy</Link></li>
            <li className="text-xs text-tan/70 pt-3">
              You must be 21+ to purchase. Please consume responsibly.
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-copper/15 bg-navy">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 space-y-4 text-xs leading-relaxed text-tan/70">
          <p data-testid="footer-fda-disclaimer" className="max-w-4xl">
            <span className="font-semibold text-tan">FDA Disclaimer:</span>{" "}
            {s?.fda_disclaimer ||
              "These statements and products have not been evaluated by the Food and Drug Administration (FDA). These products are not intended to diagnose, treat, cure, or prevent any disease. By using this site, you agree to follow the Privacy Policy and all Terms & Conditions printed on this site. Void where prohibited by law. Consult with a physician before use if you have a serious medical condition or use prescription medications. A doctor's advice should be sought before using this and any supplemental dietary product. All trademarks and copyrights are property of their respective owners and are not affiliated with, nor do they endorse, this product."}
          </p>
          <p data-testid="footer-thca-shipping-restriction" className="max-w-4xl">
            <span className="font-semibold text-tan">THCA / Shipping Restrictions:</span>{" "}
            All products contain less than 0.3% Delta-9 THC on a dry-weight basis in compliance with the 2018 Federal Farm Bill. Hemp-derived THCA and cannabinoid products may be restricted or prohibited in certain states. It is your responsibility to know and comply with the laws in your state before ordering. We do not ship to states where these products are illegal, including but not limited to Idaho, Kansas, and any jurisdiction that has banned hemp-derived THCA or Delta-8/Delta-9 THC products. Orders placed from restricted states may be canceled and refunded. You must be 21 years of age or older to purchase.
          </p>
        </div>
      </div>

      <div className="border-t border-copper/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-tan/70 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <p>You must be 21+ to purchase. Please consume responsibly.</p>
          <p>© {new Date().getFullYear()} High Achievers Texas. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
